import { render, staticRenderFns } from "./TextoTooltip.vue?vue&type=template&id=086a90db&scoped=true"
import script from "./TextoTooltip.vue?vue&type=script&lang=js"
export * from "./TextoTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086a90db",
  null
  
)

export default component.exports